import { useState } from "react";
import CopyCode from "../../CopyCode/CopyCode";

const MobileMenu = () => {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <div className="flex flex-col gap-y-10 p-6">
      {/* HAMBURGER MENUS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-white mb-6">Mobile Menus</h2>
        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Hamburger Menu</label>
            <div className="flex items-center gap-3 p-3 bg-slate-950 rounded border border-slate-600">
              <button className="w-8 h-8 flex flex-col gap-1 justify-center items-center hover:bg-slate-800 rounded">
                <div className="w-5 h-0.5 bg-slate-400"></div>
                <div className="w-5 h-0.5 bg-slate-400"></div>
                <div className="w-5 h-0.5 bg-slate-400"></div>
              </button>
              <span className="text-slate-300">Menu</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<button className="flex flex-col gap-1 justify-center">
  <div className="w-5 h-0.5 bg-slate-400"></div>
  <div className="w-5 h-0.5 bg-slate-400"></div>
  <div className="w-5 h-0.5 bg-slate-400"></div>
</button>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">X Close Button</label>
            <div className="flex items-center gap-3 p-3 bg-slate-950 rounded border border-slate-600">
              <button className="w-8 h-8 flex items-center justify-center text-2xl hover:bg-slate-800 rounded"></button>
              <span className="text-slate-300">Close</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<button className="w-8 h-8 flex items-center justify-center text-2xl">
  
</button>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Menu with Icon</label>
            <div className="flex items-center gap-3 p-3 bg-slate-950 rounded border border-slate-600">
              <button className="text-2xl hover:text-amber-400"></button>
              <span className="text-slate-300">Navigation</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<button className="text-2xl hover:text-amber-400"></button>
<span>Navigation</span>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Colored Toggle</label>
            <div className="flex items-center gap-3 p-3 bg-slate-950 rounded border border-slate-600">
              <button className="w-8 h-8 flex flex-col gap-1 justify-center items-center bg-amber-900 hover:bg-amber-800 rounded text-amber-300">
                <span className="w-4 h-0.5 bg-current"></span>
                <span className="w-4 h-0.5 bg-current"></span>
              </button>
              <span className="text-slate-300">Menu</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<button className="w-8 h-8 bg-amber-900 hover:bg-amber-800">
  <span className="w-4 h-0.5 bg-current"></span>
  <span className="w-4 h-0.5 bg-current"></span>
</button>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Animated Menu</label>
            <div className="flex items-center gap-3 p-3 bg-slate-950 rounded border border-slate-600">
              <button className="w-8 h-6 flex flex-col gap-1 justify-center items-center hover:gap-0.5 transition-all">
                <div className="w-5 h-0.5 bg-slate-400"></div>
                <div className="w-5 h-0.5 bg-slate-400"></div>
                <div className="w-5 h-0.5 bg-slate-400"></div>
              </button>
              <span className="text-slate-300">Click me</span>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<button className="hover:gap-0.5 transition-all">
  <div className="w-5 h-0.5 bg-slate-400"></div>
</button>`} />
          </div>

          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Drawer Overlay Preview</label>
            <div className="relative p-3 bg-slate-950 rounded border border-slate-600 h-20">
              <button className="absolute top-2 left-2 text-2xl"></button>
              <div className="absolute left-0 top-0 w-48 bg-slate-800 h-full border-r border-slate-600 p-4">
                <div className="text-sm text-slate-300 space-y-2">
                  <div>Home</div>
                  <div>About</div>
                </div>
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="w-48 bg-slate-800 h-full border-r">
  <div className="p-4 space-y-2">
    <div>Home</div>
  </div>
</div>`} />
          </div>
        </div>
      </div>

      {/* OVERLAY MENUS */}
      <div className="bg-slate-800 border border-slate-700 rounded-xl p-6 space-y-4">
        <h2 className="text-xl font-bold text-amber-400 mb-6">Menu Panels</h2>
        <div className="grid grid-cols-1 gap-4">
          <div className="p-3 bg-slate-900 border border-slate-600 rounded-lg">
            <label className="text-xs text-slate-400 mb-3 block font-medium">Full Menu Preview</label>
            <div className="relative p-3 bg-slate-950 rounded border border-slate-600 h-40">
              <div className="w-full bg-slate-800 rounded p-3 space-y-2">
                <div className="flex justify-between items-center border-b border-slate-600 pb-2">
                  <span className="font-medium text-slate-300">Menu</span>
                  <button></button>
                </div>
                {["Home", "Products", "Services", "About", "Contact"].map(item => (
                  <div key={item} className="px-3 py-2 hover:bg-slate-700 rounded text-slate-400 cursor-pointer">
                    {item}
                  </div>
                ))}
              </div>
            </div>
            <CopyCode number_code={Math.floor(Math.random() * 10000)} code={`<div className="w-full bg-slate-800 rounded p-3">
  <div className="flex justify-between pb-2 border-b">
    <span>Menu</span>
    <button></button>
  </div>
  <div className="py-2">Item</div>
</div>`} />
          </div>
        </div>
      </div>
    </div>
  );
};

export default MobileMenu;


